import {fetchShowMoreData, formatedPrice, renderElement, renderElements} from "../../utils/common";
import {getPreloaderTemplate} from "../utils/templates";

const COUNT_LOADED_CARDS = 20;

const cards = (listElement, buttonElement, state, removeButton, getTemplate) => {
  state.amount = +buttonElement.dataset.amount;
  state.totalPages = Math.ceil(state.amount / COUNT_LOADED_CARDS);

  const location = window.location.pathname;
  const search = window.location.search;

  const SERVER_URL = `${location}${search ? `${search}&` : `?`}`;

  buttonElement.addEventListener(`click`, () => {
    if (!state.isLoaded) {
      state.isLoaded = !state.isLoaded; // true
      renderElement(listElement, getPreloaderTemplate());

      fetchShowMoreData(SERVER_URL, state).then((data) => {
        state.isLoaded = !state.isLoaded; // false
        document.querySelector(`.js-show-more-preloader`).remove();

        renderElements(listElement, data, getTemplate);

        state.nextPage += 1;
        removeButton();
      });
    }
  });
};

export default cards;
